import { ColumnDef } from '@tanstack/react-table';
import { get } from 'lodash';
import { useMemo } from 'react';

import {
  BasicTableColumn,
  FilterType,
} from '@work4all/components/lib/dataDisplay/basic-table';

import { wrapV7Cell } from '../../wrap-v7-cell';

export function useColumnDefs(columns: BasicTableColumn[]) {
  return useMemo(() => {
    const columnDefs: ColumnDef<Record<string, any>, any>[] = columns.map(
      (column) => {
        const columnDef: ColumnDef<Record<string, any>, any> = {
          ...column,
          id: column.id,
          accessorFn:
            typeof column.accessor === 'function'
              ? (column.accessor as any)
              : (info) => get(info, column.accessor as string),
          accessorKey:
            typeof column.accessor === 'string' ? column.accessor : undefined,
          size: typeof column.width === 'number' ? column.width : undefined,
          minSize:
            typeof column.minWidth === 'number' ? column.minWidth : undefined,
          maxSize:
            typeof column.maxWidth === 'number' ? column.maxWidth : undefined,
          cell: wrapV7Cell(column.Cell),
          cellParams: column.cellParams,
          header: column.Header,
          enableSorting: !column.disableSortBy,
          enableHiding: !column.disableColumnVisibility,

          footer: column.Footer,

          isPrimaryFilter: column.isPrimaryFilter,
          filterType: column.filterType,
          enableGrouping: !column.disableGroupBy,
          sortDescFirst: false,
          enableColumnFilter: !column.disableFilters,
          enableGlobalFilter: column.quickSearchable,
          groupLabelElement: column.GroupLabelElement,
          groupLabelElementParams: column.groupLabelElementParams,
          enableResizing: !column.disableResizing,

          dataType: column.dataType,
          filterFn:
            column.filterType === FilterType.ClosedStatus
              ? 'closedStatus'
              : 'equals',
        };

        // Remove all undefined properties from the columnDef object
        Object.keys(columnDef).forEach((key) => {
          if (columnDef[key] === undefined) {
            delete columnDef[key];
          }
        });

        return columnDef;
      }
    );

    return columnDefs;
  }, [columns]);
}
